/**
 * Must load before any module that uses Node-style `process` (e.g. @azure/service-bus).
 * vite-plugin-node-polyfills uses `globalThis.process ||= polyfill`; a partial `process`
 * (env-only) can skip the real polyfill and break `process.nextTick`.
 *
 * Import the bare `process` specifier (not `process/browser`): the plugin aliases
 * `process` to its full browser shim, and a `/browser` subpath would make Vite 8
 * treat that alias as a folder-to-folder mapping and fail to resolve.
 */
import process from 'process';

if (typeof globalThis !== 'undefined') {
  const existing = globalThis.process as { nextTick?: unknown } | undefined;
  if (typeof existing === 'undefined' || typeof existing.nextTick !== 'function') {
    (globalThis as unknown as { process: typeof process }).process = process;
  }
}
